import { useMutation } from 'react-query';
import { requestPasswordReset } from 'services/userService';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';

export const useRequestResetPasswordMutation = () => {
  const { baseAxios } = useDoctorPortalApiContext();

  return useMutation(requestPasswordReset(baseAxios));
};
